module.exports = __webpack_public_path__ + "img/gif-bounce-arrow-down.d6e2538d.gif";